{
	"backToManageDeclarations": "Volver a Gestionar declaraciones"
}
